import { useMemo, useState } from "react";
import { BookOpen } from "lucide-react";
import { toast } from "sonner";
import { useLayout } from "@/context/LayoutContext";
import { useUnit } from "@/context/UnitContext";
import { useMenuCategories } from "@/lib/menuOrder";
import { exportMenuPdf, groupByCategory } from "@/lib/menuPdf";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button, Field, Input, Segmented } from "@/components/kit";

const STYLES = [
  { value: "list", label: "Lista com fotos" },
  { value: "grid", label: "Grade de fotos" },
];

export default function MenuPdfDialog({ open, onOpenChange, recipes }) {
  const { layout } = useLayout();
  const { unit } = useUnit();
  const { data: cats = [] } = useMenuCategories();
  const [style, setStyle] = useState("list");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const groups = useMemo(() => groupByCategory(recipes, cats), [recipes, cats]);
  const count = groups.reduce((n, g) => n + g.items.length, 0);
  const noPrice = recipes.filter((r) => !r.is_base && !(r.sale_price > 0)).length;
  const go = () => {
    const ok = exportMenuPdf(groups, { style, title: title.trim() || layout?.app_name || "Cardápio", subtitle: subtitle.trim(), logoUrl: layout?.logo_url, brand: layout?.brand || "#4E6E5D", font: "Playfair Display" });
    if (!ok) return toast.error("Não foi possível gerar o PDF");
    onOpenChange(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[var(--surface)] text-[var(--text)] border-[var(--border)] rounded-2xl" data-testid="menu-pdf-dialog">
        <DialogTitle className="flex items-center gap-2"><BookOpen size={18} style={{ color: "var(--brand)" }} /> Cardápio em PDF</DialogTitle>
        <DialogDescription>Para o cliente · fotos, descrição e preço, com as categorias na ordem definida.</DialogDescription>
        <Segmented options={STYLES} value={style} onChange={setStyle} testid="menu-pdf-style" />
        <Field label="Título"><Input placeholder={layout?.app_name || "Nome do restaurante"} value={title} onChange={(e) => setTitle(e.target.value)} data-testid="menu-pdf-title-input" /></Field>
        <Field label="Subtítulo (opcional)"><Input placeholder={unit?.name ? `Ex.: ${unit.name} · Almoço e jantar` : "Ex.: Almoço e jantar"} value={subtitle} onChange={(e) => setSubtitle(e.target.value)} data-testid="menu-pdf-subtitle-input" /></Field>
        <p className="caption" data-testid="menu-pdf-summary">{count} prato(s) em {groups.length} categoria(s){noPrice ? ` · ${noPrice} sem preço de venda ficam de fora` : ""}. Preparos base não entram.</p>
        <Button icon={BookOpen} onClick={go} disabled={!count} data-testid="menu-pdf-generate-button">Gerar cardápio</Button>
      </DialogContent>
    </Dialog>
  );
}
